import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IMucThuKhacSinhVienSaveHocPhiTinChiRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSaveHocPhiTinChiRequest";
import { IMucThuKhacSinhVienSelectByLopsRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienSelectByLopsRequest";
import { IDanhSachLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IDanhSachLopTinChiSelectRequest";
import { ISinhVienSelectByLopsRequest } from "../../../model/request/sinh-vien/ISinhVienSelectByLopsRequest";
import { IStuHoSoSinhVienViewModel } from "../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IMucThuKhacSinhVien } from "../../../model/respone/chung-tu/IMucThuKhacSinhVien";
import { ISinhVienLopTinChiSoTienCalculateRespone } from "../../../model/respone/lop-tin-chi/ISinhVienLopTinChiSoTienCalculateRespone";
import { IMucThuTinChiCalculate } from "../../reducer-model/muc-thu/IMucThuTinChiReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eMucThuTinChiActionsObj = {
  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_LOAI_THU_CHI: 0,
  CHANGE_KY_DANG_KY: 0,
  CHANGE_TRANG_THAI_HOC: [] as number[],
  CHANGE_TRANG_TONG_HOP: "",

  LOAD_HOCSINH_START: {} as ISinhVienSelectByLopsRequest,
  LOAD_HOCSINH_SUCCESS: {} as IStuHoSoSinhVienViewModel[],
  LOAD_HOCSINH_ERRR: "",

  CALCULATE_START: {} as IDanhSachLopTinChiSelectRequest,
  CALCULATE_SUCCESS: {} as ISinhVienLopTinChiSoTienCalculateRespone,
  CALCULATE_ERRR: "",

  UPDATE_CALCULATE_STATE: {} as IMucThuTinChiCalculate,

  SAVE_CALCULATE_START: {} as IMucThuKhacSinhVienSaveHocPhiTinChiRequest,
  SAVE_CALCULATE_SUCCESS: undefined,
  SAVE_CALCULATE_ERRR: "",

  LOAD_MUCTHUKHAC_START: {} as IMucThuKhacSinhVienSelectByLopsRequest,
  LOAD_MUCTHUKHAC_SUCCESS: {} as IMucThuKhacSinhVien[],
  LOAD_MUCTHUKHAC_ERRR: "",
};
export const eMucThuTinChiActionIds = generateActionTypeIds(
  eMucThuTinChiActionsObj,
  "MUC_THU_TIN_CHI"
);
export type IMucThuTinChiActionTypes = IGenericActionType<
  typeof eMucThuTinChiActionsObj,
  "MUC_THU_TIN_CHI"
>;
